import { CircularProgress, Container, LinearProgress } from '@mui/material';
import React from 'react';

export default function ListLoading({ linear }) {
    return (
        <Container
            maxWidth="sm"
            style={{
                paddingTop: !linear && 102,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                textAlign: 'center',
            }}
        >
            {linear ? (
                <div className="w-100">
                    <LinearProgress />
                </div>
            ) : (
                <CircularProgress />
            )}
        </Container>
    );
}
